"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCancelToken = exports.deletehWithRetryAsync = exports.patchWithRetryAsync = exports.putWithRetryAsync = exports.postWithRetryAsync = exports.getWithRetryAsync = void 0;
var axios_1 = require("axios");
var headers_helper_1 = require("../helpers/headers-helper");
var http_debugger_1 = require("./http.debugger");
var retry_helper_1 = require("../helpers/retry-helper");
function getWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retry_helper_1.retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            http_debugger_1.httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.get(call.url, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: (0, headers_helper_1.extractHeadersFromAxiosResponse)(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            http_debugger_1.httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.getWithRetryAsync = getWithRetryAsync;
function postWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retry_helper_1.retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            http_debugger_1.httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.post(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: (0, headers_helper_1.extractHeadersFromAxiosResponse)(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            http_debugger_1.httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.postWithRetryAsync = postWithRetryAsync;
function putWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retry_helper_1.retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            http_debugger_1.httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.put(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: (0, headers_helper_1.extractHeadersFromAxiosResponse)(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            http_debugger_1.httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.putWithRetryAsync = putWithRetryAsync;
function patchWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retry_helper_1.retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            http_debugger_1.httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.patch(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: (0, headers_helper_1.extractHeadersFromAxiosResponse)(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            http_debugger_1.httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.patchWithRetryAsync = patchWithRetryAsync;
function deletehWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retry_helper_1.retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            http_debugger_1.httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.delete(call.url, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: (0, headers_helper_1.extractHeadersFromAxiosResponse)(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            http_debugger_1.httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.deletehWithRetryAsync = deletehWithRetryAsync;
function createCancelToken() {
    var canceler;
    var token = new axios_1.default.CancelToken(function (c) {
        // An executor function receives a cancel function as a parameter
        canceler = c;
    });
    return {
        cancel: function (cancelMessage) {
            return canceler(retry_helper_1.retryHelper.requestCancelledMessagePrefix + ": " + (cancelMessage !== null && cancelMessage !== void 0 ? cancelMessage : 'User cancel'));
        },
        token: token
    };
}
exports.createCancelToken = createCancelToken;
function runWithRetryAsync(data) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1, retryResult_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 6]);
                    return [4 /*yield*/, data.call(data.retryAttempt)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_1 = _a.sent();
                    retryResult_1 = retry_helper_1.retryHelper.getRetryErrorResult({
                        error: error_1,
                        retryAttempt: data.retryAttempt,
                        retryStrategy: data.retryStrategy
                    });
                    if (!retryResult_1.canRetry) return [3 /*break*/, 5];
                    http_debugger_1.httpDebugger.debugRetryHttpRequest();
                    // wait time before retrying
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, retryResult_1.retryInMs); })];
                case 3:
                    // wait time before retrying
                    _a.sent();
                    // retry request
                    console.warn("Retry attempt '" + (data.retryAttempt + 1) + "' from a maximum of '" + retryResult_1.maxRetries + "' retries. Request url: '" + data.url + "'");
                    return [4 /*yield*/, runWithRetryAsync({
                            call: data.call,
                            retryStrategy: data.retryStrategy,
                            retryAttempt: data.retryAttempt + 1,
                            url: data.url,
                            functionsConfig: data.functionsConfig
                        })];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    if (data.functionsConfig.logErrorsToConsole) {
                        console.error("Executing '" + data.url + "' failed. Request was retried '" + data.retryAttempt + "' times. ", error_1);
                    }
                    throw error_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getHeadersJson(headers, addContentTypeHeader) {
    var headerJson = {};
    headers.forEach(function (header) {
        headerJson[header.header] = header.value;
    });
    if (addContentTypeHeader) {
        // add default content type header if not present
        var contentTypeHeader = headers.find(function (m) { return m.header.toLowerCase() === 'Content-Type'.toLowerCase(); });
        if (!contentTypeHeader) {
            headerJson['Content-Type'] = 'application/json';
        }
    }
    return headerJson;
}
//# sourceMappingURL=http.functions.js.map